import React from 'react'

const Jva_sel = () => {
    return (
        <div className='container'> 
          
<h1 class="h1">Selection Sort in Java</h1>

<p>We can create a java program to sort array elements using selection sort. In selection sort algorithm, we search
  for the lowest element and arrange it to the proper location. We swap the current element with the next lowest
  plain.</p>


<h2 class="h2">How does selection sort work?</h2>
<p>The selection sort algorithm works in a very simple way. It maintains two subarray for the given array.</p>
<ul>
  <li>The subarray is already sorted.</li>
  <li>And the second subarray is unsorted.</li>
</ul>
<p>With every iteration of selection sort, an element is picked from the unsorted subarray and moved to the sorted
  subarray.</p>
<div class="containers">
  <div class="dp-highlighter">
    <div class="bar">
    
    <ul start="1" class="dp-j">
      <li class="alt"><span><span>arr[]&nbsp;=&nbsp;</span><span class="plain">25</span><span>&nbsp;</span><span
            class="plain">35</span><span>&nbsp;</span><span class="plain">45</span><span>&nbsp;</span><span
            class="plain">12</span><span>&nbsp;</span><span class="plain">65</span><span>&nbsp;</span><span
            class="plain">10</span><span>&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;</span></li>
      <li class="alt"><span><span
            class="comment">//&nbsp;Find&nbsp;the&nbsp;minimum&nbsp;element&nbsp;in&nbsp;arr[0...5]&nbsp;and&nbsp;place&nbsp;it&nbsp;at&nbsp;beginning.</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span>&nbsp;&nbsp;</span></li>
      <li class="alt"><span><span class="plain">10</span><span>&nbsp;</span><span
            class="plain">25</span><span>&nbsp;</span><span class="plain">35</span><span>&nbsp;</span><span
            class="plain">45</span><span>&nbsp;</span><span class="plain">12</span><span>&nbsp;</span><span
            class="plain">65</span><span>&nbsp;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;</span></li>
      <li class="alt"><span><span
            class="comment">//&nbsp;Find&nbsp;the&nbsp;minimum&nbsp;element&nbsp;in&nbsp;arr[1...5]&nbsp;and&nbsp;place&nbsp;it&nbsp;at&nbsp;beginning&nbsp;of&nbsp;arr[1...5]</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span>&nbsp;&nbsp;</span></li>
      <li class="alt"><span><span class="plain">10</span><span>&nbsp;</span><span
            class="plain">12</span><span>&nbsp;</span><span class="plain">25</span><span>&nbsp;</span><span
            class="plain">35</span><span>&nbsp;</span><span class="plain">45</span><span>&nbsp;</span><span
            class="plain">65</span><span>&nbsp;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;</span></li>
      <li class="alt"><span><span
            class="comment">//&nbsp;Find&nbsp;the&nbsp;minimum&nbsp;element&nbsp;in&nbsp;arr[2...5]&nbsp;and&nbsp;place&nbsp;it&nbsp;at&nbsp;beginning&nbsp;of&nbsp;arr[2...5]</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class="">
        <span>No,&nbsp;you&nbsp;can&nbsp;see&nbsp;that&nbsp;the&nbsp;array&nbsp;is&nbsp;already&nbsp;sorted.&nbsp;&nbsp;&nbsp;</span>
      </li>
      <li class="alt"><span>&nbsp;&nbsp;</span></li>
      <li class=""><span><span class="plain">10</span><span>&nbsp;</span><span
            class="plain">12</span><span>&nbsp;</span><span class="plain">25</span><span>&nbsp;</span><span
            class="plain">35</span><span>&nbsp;</span><span class="plain">45</span><span>&nbsp;</span><span
            class="plain">65</span><span>&nbsp;&nbsp;&nbsp;</span></span></li>
      </ul>
  </div>
</div>
</div>
<h2>Time Complexity</h2>
<strong>Best:</strong> (n^2)<br/>
<strong>Average:</strong> (n^2)<br/>
<strong>Worst:</strong> O(n^2)

<h2>Space Complexity</h2>
O(1)

<h2 class="h2">Selection Sort Java Example</h2>
<div class="containers">
  <div class="dp-highlighter">
    <div class="bar">
    
    <ul start="1" class="dp-j">
      <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">class</span><span>&nbsp;SelectionSortExample&nbsp;&#123;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;selectionSort(</span><span
            class="keywords">int</span><span>[]&nbsp;arr)&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">for</span><span>&nbsp;(</span><span
            class="keywords">int</span><span>&nbsp;i&nbsp;=&nbsp;</span><span
            class="plain">0</span><span>;&nbsp;i&nbsp;&lt;&nbsp;arr.length&nbsp;-&nbsp;</span><span
            class="plain">1</span><span>;&nbsp;i++)&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">int</span><span>&nbsp;index&nbsp;=&nbsp;i;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">for</span><span>&nbsp;(</span><span
            class="keywords">int</span><span>&nbsp;j&nbsp;=&nbsp;i&nbsp;+&nbsp;</span><span
            class="plain">1</span><span>;&nbsp;j&nbsp;&lt;&nbsp;arr.length;&nbsp;j++)&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">if</span><span>&nbsp;(arr[j]&nbsp;&lt;&nbsp;arr[index])&#123;&nbsp;&nbsp;</span></span></li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;index&nbsp;=&nbsp;j;<span
            class="comment">//searching&nbsp;for&nbsp;lowest&nbsp;index</span><span>&nbsp;&nbsp;</span></span></li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span>
      </li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span>
      </li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">int</span><span>&nbsp;smallerplain&nbsp;=&nbsp;arr[index];&nbsp;&nbsp;&nbsp;</span></span>
      </li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;arr[index]&nbsp;=&nbsp;arr[i];&nbsp;&nbsp;</span>
      </li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;arr[i]&nbsp;=&nbsp;smallerplain;&nbsp;&nbsp;</span>
      </li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;main(String&nbsp;a[])&#123;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">int</span><span>[]&nbsp;arr1&nbsp;=&nbsp;&#123;</span><span
            class="plain">9</span><span>,</span><span class="plain">14</span><span>,</span><span
            class="plain">3</span><span>,</span><span class="plain">2</span><span>,</span><span
            class="plain">43</span><span>,</span><span class="plain">11</span><span>,</span><span
            class="plain">58</span><span>,</span><span class="plain">22</span><span>&#125;;&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
            class="string">"Before&nbsp;Selection&nbsp;Sort"</span><span>);&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">for</span><span>(</span><span
            class="keywords">int</span><span>&nbsp;i:arr1)&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.print(i+<span
            class="string">"&nbsp;"</span><span>);&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println();&nbsp;&nbsp;</span>
      </li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;selectionSort(arr1);<span
            class="comment">//sorting&nbsp;array&nbsp;using&nbsp;selection&nbsp;sort</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
            class="string">"After&nbsp;Selection&nbsp;Sort"</span><span>);&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">for</span><span>(</span><span
            class="keywords">int</span><span>&nbsp;i:arr1)&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.print(i+<span
            class="string">"&nbsp;"</span><span>);&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
      <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
        </ul>
  </div>
</div>
</div>
<p>Output:</p>
<div class="output">
  <pre>Before Selection Sort
9 14 3 2 43 11 58 22 
After Selection Sort
2 3 9 11 14 22 43 58 
</pre>
</div>
<h2 class="h2">Selection Sort in Java (Another way)</h2>
<p>You can also use a method where array is not predefined. Here, user has to put the elements as input.</p>
<p>In the following Java program, we ask user to enter the array elements or plain, now compare the array's element
  and start swapping with the variable temp. Put the first element in the temp and the second element in the first,
  and then temp in the second plain and continue for the next match to sort the whole array in ascending order.</p>

<div class="containers">
  <div class="dp-highlighter">
    <div class="bar">
     
    </div>
    <ul start="1" class="dp-j">
      <li class="alt"><span><span
            class="keywords">import</span><span>&nbsp;java.util.Scanner;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;</span></li>
      <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">class</span><span>&nbsp;SelectionSortExample2&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&#123;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;<span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">int</span><span>&nbsp;size,&nbsp;i,&nbsp;j,&nbsp;temp;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">int</span><span>&nbsp;arr[]&nbsp;=&nbsp;</span><span
            class="keywords">new</span><span>&nbsp;</span><span class="keywords">int</span><span>[</span><span
            class="plain">50</span><span>];&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Scanner&nbsp;scan&nbsp;=&nbsp;<span
            class="keywords">new</span><span>&nbsp;Scanner(System.in);&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.print(<span
            class="string">"Enter&nbsp;Array&nbsp;Size&nbsp;:&nbsp;"</span><span>);&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;size&nbsp;=&nbsp;scan.nextInt();&nbsp;&nbsp;</span>
      </li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.print(<span
            class="string">"Enter&nbsp;Array&nbsp;Elements&nbsp;:&nbsp;"</span><span>);&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">for</span><span>(i=</span><span
            class="plain">0</span><span>;&nbsp;i&lt;size;&nbsp;i++)&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span></li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;arr[i]&nbsp;=&nbsp;scan.nextInt();&nbsp;&nbsp;</span>
      </li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.print(<span
            class="string">"Sorting&nbsp;Array&nbsp;using&nbsp;Selection&nbsp;Sort&nbsp;Technique..\n"</span><span>);&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">for</span><span>(i=</span><span
            class="plain">0</span><span>;&nbsp;i&lt;size;&nbsp;i++)&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">for</span><span>(j=i+</span><span
            class="plain">1</span><span>;&nbsp;j&lt;size;&nbsp;j++)&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span></li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">if</span><span>(arr[i]&nbsp;&gt;&nbsp;arr[j])&nbsp;&nbsp;</span></span></li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span>
      </li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;temp&nbsp;=&nbsp;arr[i];&nbsp;&nbsp;</span>
      </li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;arr[i]&nbsp;=&nbsp;arr[j];&nbsp;&nbsp;</span>
      </li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;arr[j]&nbsp;=&nbsp;temp;&nbsp;&nbsp;</span>
      </li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span>
      </li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span>
      </li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.print(<span
            class="string">"Now&nbsp;the&nbsp;Array&nbsp;after&nbsp;Sorting&nbsp;is&nbsp;:\n"</span><span>);&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">for</span><span>(i=</span><span
            class="plain">0</span><span>;&nbsp;i&lt;size;&nbsp;i++)&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span></li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.print(arr[i]+&nbsp;<span
            class="string">"&nbsp;&nbsp;"</span><span>);&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
      <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
        </ul>
  </div>
</div>
<p>Output:</p>
<strong> Use image SelectionSort</strong>
</div>

        
    )
}

export default Jva_sel
